module.exports = __webpack_public_path__ + "static/media/Fraz_portfolio_hero_high_quality.f20143fd.png";